import { ILmsProfileModel } from 'models/lmsProfile.model'
import api from '../../..'

const destroyManyProfileUsers = (
  id: number | string,
  q: { id_not_in?: number[]; id_in?: number[] }
) =>
  api
    .delete(`administration/lms_profiles/${id}/users/destroy_many`, {
      data: { q },
    })
    .then(({ data }): ILmsProfileModel => data)

export default destroyManyProfileUsers
